<!-- RoleSelectionModal.vue -->
<template>
    <q-dialog v-model="isOpen" persistent>
      <q-card class="role-selection-modal">
        <q-card-section class="text-center q-pb-none">
          <h3 class="text-h5 q-mt-sm">{{ $t('selectRole') }}</h3>
        </q-card-section>
        <q-card-section class="q-pt-sm">
          <p class="text-body1">{{ $t('multipleRolesMessage') }}</p>
          
          <q-list separator>
            <q-item 
              v-for="category in groupedRoles" 
              :key="category.name" 
              clickable 
              v-ripple 
              @click="selectRole(category.roles[0])"
              class="role-option q-my-sm"
            >
              <q-item-section avatar>
                <q-icon :name="getRoleIcon(category.name)" color="primary" size="md" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="text-subtitle1 text-weight-medium">{{ getRoleLabel(category.name) }}</q-item-label>
                <q-item-label caption>{{ getRoleDescription(category.name) }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>
      </q-card>
    </q-dialog>
  </template>
  
  <script>
  export default {
    name: 'RoleSelectionModal',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      availableRoles: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set(value) {
          this.$emit('update:visible', value);
        }
      },
      // Group roles by their main category (admin, teacher, parent, child)
      groupedRoles() {
        const categories = {};
        
        // Process all roles and only keep one entry per role category
        this.availableRoles.forEach(role => {
          // Extract the base role name (admin, teacher, parent, child)
          const baseRole = role.name;
          
          // Only add the role category if we haven't seen it before
          if (!categories[baseRole]) {
            categories[baseRole] = {
              name: baseRole,
              roles: [role] // Store just the first role we find for this category
            };
          }
        });
        
        console.log('Grouped roles for selection:', Object.values(categories));
        return Object.values(categories);
      }
    },
    methods: {
      getRoleIcon(roleName) {
        const icons = {
          admin: 'admin_panel_settings',
          teacher: 'school',
          parent: 'family_restroom',
          child: 'child_care'
        };
        return icons[roleName] || 'person';
      },
      getRoleLabel(roleName) {
        const labels = {
          admin: this.$t('administrator'),
          teacher: this.$t('teacher'),
          parent: this.$t('parent'),
          child: this.$t('child')
        };
        return labels[roleName] || roleName;
      },
      getRoleDescription(roleName) {
        const descriptions = {
          admin: this.$t('adminDescription'),
          teacher: this.$t('teacherDescription'),
          parent: this.$t('parentDescription'),
          child: this.$t('childDescription')
        };
        return descriptions[roleName] || '';
      },
      selectRole(role) {
        this.$emit('role-selected', role);
        this.isOpen = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .role-selection-modal {
    min-width: 350px;
    max-width: 450px;
    border-radius: 12px;
  }
  
  .role-option {
    border-radius: 8px;
    transition: background-color 0.3s;
  }
  
  .role-option:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  </style>